import { useTranslation } from 'next-i18next';
import { useEffect, useState } from 'react';

import { Tooltip } from 'components';
import { ButtonV3 } from 'components/ComponentV2';
import { CVUploadModalInstance } from 'components/candidate/CVUploadModal';
import { useResponsive } from 'hooks/useResponsive';
import { useCandidateProfile } from 'lib/contexts/candidate-profile-context';
import { useAuth } from 'lib/providers/AuthProvider';
import { REGEX } from 'lib/utils/regex';

import { getExperienceInfo } from '../Experience/utils';
import { getSchoolInfo, getUniversityInfo } from '../Education/utils';
import styles from './CVSection.module.scss';

export const CVSection = () => {
  const [isGeneratingCV, setIsGeneratingCV] = useState(false);
  const [t] = useTranslation('candidate.profile');

  const screens = useResponsive();

  const [resumeUrl, setResumeUrl] = useState<string | null>(null);
  const [isInvalid, setIsInvalid] = useState(false);

  const onSubmit = async () => {
    if (isInvalid) return;

    setIsGeneratingCV(true);
    await generateCV();
    setIsGeneratingCV(false);
  };

  const { generateCV } = useCandidateProfile();

  const { candidate } = useAuth();

  useEffect(() => {
    if (candidate) {
      const { first_name, last_name, linkedin_url, resume_url } = candidate;
      const experienceInfo = getExperienceInfo(candidate);
      const universityInfo = getUniversityInfo(candidate);
      const schoolInfo = getSchoolInfo(candidate);
      setIsInvalid(
        !first_name ||
          !last_name ||
          (linkedin_url && !REGEX.URL_CHECK.test(linkedin_url)) ||
          (universityInfo.length === 0 && schoolInfo.length === 0) ||
          experienceInfo.length === 0
      );

      setResumeUrl(resume_url);
    }
  }, [candidate]);

  const handleCVUpload = async () => {
    try {
      await CVUploadModalInstance();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <article className={styles.container}>
      <section className={styles.main}>
        <Tooltip
          content={t('cv-section.tooltip-content')}
          position="top"
          xAlign="center"
          color="dark"
          containerClassName={styles['button-container']}
          disabled={screens.sm || !isInvalid}
        >
          <ButtonV3
            isFullWidth
            size="large"
            disabled={isGeneratingCV}
            onClick={() => {
              onSubmit();
            }}
            isLoading={isGeneratingCV}
          >
            {t('cv-section.generate-cv')}
          </ButtonV3>
        </Tooltip>
        {resumeUrl ? (
          <p className={styles.bottom} onClick={handleCVUpload}>
            {t('cv-section.your-cv')}
          </p>
        ) : (
          <p className={styles.bottom} onClick={handleCVUpload}>
            {t('cv-section.upload-cv')}
          </p>
        )}
      </section>
    </article>
  );
};
